import { Outlet } from "react-router-dom"

export const TemplateMain: React.FC = () => {

	return <div className="container-fluid p-0 overflow-hidden" id="main">
		<Outlet />
	</div>
}